import {Component, Inject} from '@angular/core';
import {MAT_SNACK_BAR_DATA} from '@angular/material/snack-bar';
import {HttpErrorResponse, HttpResponse} from '@angular/common/http';

@Component({
    selector: 'app-be-msg-error',
    templateUrl: './be-msg-error.component.html',
    styleUrls: ['./be-msg-error.component.css']
})
export class BeMsgErrorComponent {

    constructor(@Inject(MAT_SNACK_BAR_DATA) public data: any) {


    }


}
